import { render, staticRenderFns } from "./CustomerReportTable.vue?vue&type=template&id=4373f71a"
import script from "./CustomerReportTable.vue?vue&type=script&lang=js"
export * from "./CustomerReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports